import AccountInventoryService from '@/services/accountinventory.service.js'
import awsAcctService from '@/services/awsacct.service.js'
import changeLogService from '@/services/changelog.service.js'
import OppregAdminService from '@/services/oppregadmin.service'
import AttestationService from '@/services/attestation.service'


export default {
  getAttestationRequest: (context, id) => {
    console.log('action')
    context.commit('setLoadingRequest', true)
    AttestationService.getAttestationRequest(id, (err, res) => {
      if (err) {

      } else {

        if (id) {
          context.commit('setRequestDetail', res)
        } else {
          context.commit('setLoadingRequest', false)
          context.commit('setViewRequestsData', res)
        }
      }
    })
  },


  updateAttestation: (context, request) => {
    console.log('attestation submit', request)
    context.commit('setUpdatingRequest', true)
    AttestationService.updateAttestation(request, (err, res) => {
      if (err) {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while updating the request. Please contact administrator'
          },
          { root: true }
        )

      } else {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'success',
            timeout: 10000,
            message: 'Successfully updated request'
          },
          { root: true }
        )
      }
      context.commit('setUpdatingRequest', false)
    })
  },

  downloadFile: (context, name) => {
    console.log('action downlaod file')

    AttestationService.downloadDocument(name, (err, res) => {
      if (err) {

      } else {
        window.open(res, '_blank')
      }
    })

  },

  getAttestationDetail: context => {
    console.log('action')
    context.commit('setLoadingRequest', true)
    AttestationService.getAccountAttestationDetail((err, res) => {
      if (err) {

      } else {
        console.log('setting response', res)
        context.commit('setLoadingRequest', false)
        context.commit('setViewRequestsData', res)
      }
    })
  }
}